import React from "react";
import DataGridComponent from "../components/tables/DataGrid";
import { useSelector, useDispatch } from "react-redux";
import useDataGrid from "../hooks/useDataGrid";
import { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb/BreadCrumb";
import { deleteTypesOfDocument, getAllTypesOfDocuments } from "../redux/slices/inventory";
import TypeOfDocumentModalCreate from "../components/modal/TypeOfDocumentModalCreate";
import TypeOfDocumentModalUpdate from "../components/modal/TypeOfDocumentModalUpdate";
import { deleteOtType, getOtTypes } from "../redux/slices/workOrders";
import OtTypeCreateModal from "../components/modal/OtTypeCreateModal";
import OtTypeEditModal from "../components/modal/OtTypeEditModal";

export default function OtType() {
  const permitedRenderDataColumn = [
    { title: "ID", value: "id", hide: true },
    { title: "Descripcion", value: "descripcion" },
    { title: "Acciones", value: "acciones_mantenedores" },
  ];
  const [open, setOpen] = useState({
    status: false,
    data: null,
  });

  const { ot_types, success } = useSelector((state) => state.workOrders);
  const dispatch = useDispatch();

  const handleDelete = async (params) => {
    const id = params.id;
    dispatch(deleteOtType(id));
    setOpen({ status: false, data: null });
  };

  const [columns] = useDataGrid(permitedRenderDataColumn, handleDelete, "", false, setOpen);

  useEffect(() => {
    dispatch(getOtTypes());
  }, [dispatch]);

  return (
    <div>
      <div className="flex justify-between my-2 items-center bg-[#2b2c84]/20 px-5 py-2 rounded">
        <div>
          <h1 className="font-semibold text-[#1E293B] text-2xl">Tipo de OT</h1>
          <BreadCrumb origin={"Mantenedores"} current={"Tipo de OT"} />
        </div>
        <div>
          <OtTypeCreateModal />
          <OtTypeEditModal open={open.status} data={open.data} setOpen={setOpen} />
        </div>
      </div>
      <DataGridComponent columns={columns} rows={ot_types} success={success} />
    </div>
  );
}
